import { apiClient } from './client';

export interface LeadListItem {
  key: string; // project_prospect uuid
  prospect: {
    key: string;
    full_name: string;
    first_name?: string;
    last_name?: string;
    title?: string;
    location?: string;
    linkedin_public_url?: string;
    linkedin_url?: string;
    profile_image?: string | { url?: string };
    current_company?: { name?: string };
    email?: string;
  } | null;
  stream_uuid?: string | null;
  stream?: any;
  step_categories: string[];
  activity_summary?: string;
  chat_history_summary?: string;
}

export interface LeadListResponse {
  output: {
    items: LeadListItem[];
    next_page_token?: string;
    previous_page_token?: string;
    total_results?: number;
  };
}

export const leadsApi = {
  list: async (params: {
    stream?: string[];
    step_categories?: string[];
    search?: string;
    operator_uuid?: string;
    team_uuid?: string;
    activity?: string;
    happened_after?: string;
    happened_before?: string;
    sort_field?: string;
    sort_direction?: string;
    page_token?: string;
    max_results?: number;
  }): Promise<LeadListResponse> => {
    const response = await apiClient.get('/leads/', {
      params,
      paramsSerializer: {
        serialize: (p: any) => {
          const usp = new URLSearchParams();
          Object.entries(p).forEach(([key, value]) => {
            if (value === undefined || value === null) return;
            if (Array.isArray(value)) {
              value.forEach((v) => usp.append(`${key}[]`, String(v)));
            } else {
              usp.append(key, String(value));
            }
          });
          return usp.toString();
        },
      },
    });
    return response.data as LeadListResponse;
  },

  exportCsv: async (params: {
    project?: string[];
    stream?: string[];
    step_categories?: string[];
    search?: string;
    operator_uuid?: string;
    team_uuid?: string;
    activity?: string;
    happened_after?: string;
    happened_before?: string;
    sort_field?: string;
    sort_direction?: string;
  }): Promise<Blob> => {
    const response = await apiClient.get('/leads/export/', {
      params,
      responseType: 'blob',
      paramsSerializer: {
        serialize: (p: any) => {
          const usp = new URLSearchParams();
          Object.entries(p).forEach(([key, value]) => {
            if (value === undefined || value === null) return;
            if (Array.isArray(value)) {
              value.forEach((v) => usp.append(`${key}[]`, String(v)));
            } else {
              usp.append(key, String(value));
            }
          });
          return usp.toString();
        },
      },
    });
    return response.data as Blob;
  },
};


